import { MenuItemProps, Stack, Typography } from "@mui/material";
import {
  IconButton,
  useTypography,
} from "@surya-digital/leo-reactjs-material-ui";
import { ListPlus, X } from "lucide-react";
import { observer } from "mobx-react";
import React from "react";
import { useSurveyRuleStore } from "../../stores/Hooks";
import { MenuButton } from "../../../../components/buttons/MenuButton";
import { useTranslation } from "react-i18next";
import { EMPTY_CHARACTER } from "@pulse/shared-components";

interface SurveyRuleRowActionButtonsProps {
  ruleId: string;
}

export const SurveyRuleRowActionButtons: React.FC<SurveyRuleRowActionButtonsProps> =
  observer(({ ruleId }) => {
    const { t } = useTranslation();
    const typography = useTypography();

    const surveyRuleStore = useSurveyRuleStore();

    const order = surveyRuleStore.rulesOrder.indexOf(ruleId) + 1;
    const addRuleButtonMenuItems: MenuItemProps[] = [
      {
        children: t("surveys.rules.addRule"),
        onClick: () => surveyRuleStore.addNewRule("SINGLE", order),
      },
      {
        children: t("surveys.rules.addGroup"),
        onClick: () => surveyRuleStore.addNewRule("GROUP", order),
      },
    ];

    return (
      <Stack direction="row">
        <MenuButton
          button={{
            icon: <ListPlus />,
            name: "addRule",
            size: "large",
            variant: "plain-neutral",
            label: EMPTY_CHARACTER,
          }}
          menuItems={addRuleButtonMenuItems.map(
            ({ children, ...menuItemProps }) => ({
              children: <Typography {...typography.b1}>{children}</Typography>,
              ...menuItemProps,
            }),
          )}
        />
        <IconButton
          name="deleteRule"
          size="large"
          icon={<X />}
          variant="plain-neutral"
          onClick={() => surveyRuleStore.removeSurveyRule(ruleId)}
        />
      </Stack>
    );
  });
